/**
 * Podsumowanie pozycji nowego dokumentu sprzedaży — WYŁĄCZNIE podgląd.
 *
 * Kwoty autorytatywne wylicza Symfonia przy zapisie (cennik, rabaty, zaokrąglenia). To liczenie
 * służy temu, żeby użytkownik widział, co składa, zanim wyśle.
 *
 * SEDNO: rodzaj ceny decyduje, co znaczy wpisana kwota. Przy `GROSS` cena jest kwotą BRUTTO
 * i netto wychodzi z niej przez podzielenie przez stawkę; przy `NET` odwrotnie. Pomylenie tych
 * dwóch kierunków nie daje błędu, tylko podsumowanie rozjeżdżające się z dokumentem — dokładnie
 * to złapał dokument testowy `0324/26/FVS` (1,00 brutto pokazane jako 1,23).
 */

import { HM_PRICE_KINDS } from '@saas/shared';

export interface TotalsRow {
  quantity: number;
  unitPrice: number;
  /** Stawka VAT w procentach; `null` = nieznana (liczymy jak 0%, bo nie zgadujemy). */
  vatPercent: number | null;
}

export interface SaleTotals {
  net: number;
  vat: number;
  gross: number;
}

export function computeSaleTotals(rows: TotalsRow[], priceKind: number): SaleTotals {
  let net = 0;
  let gross = 0;

  for (const row of rows) {
    const value = row.quantity * row.unitPrice;
    const rate = (row.vatPercent ?? 0) / 100;

    if (priceKind === HM_PRICE_KINDS.GROSS) {
      gross += value;
      net += value / (1 + rate);
    } else {
      net += value;
      gross += value * (1 + rate);
    }
  }

  // Zaokrąglamy dopiero SUMY, nie każdą pozycję — inaczej grosze z zaokrągleń kumulują się
  // i podsumowanie rozjeżdża się z dokumentem tym bardziej, im więcej pozycji.
  const round = (n: number) => Math.round(n * 100) / 100;
  const roundedNet = round(net);
  const roundedGross = round(gross);
  return { net: roundedNet, gross: roundedGross, vat: round(roundedGross - roundedNet) };
}
